import React from 'react';
import './SnowAnimation.css';

const SnowAnimation = React.memo(({ 
  count = 60, 
  enabled = true,
  intensity = 'medium' // 'light', 'medium', 'heavy'
}) => {
  // Don't render if disabled
  if (!enabled) return null;

  // Adjust count based on intensity
  const intensitySettings = {
    light: { count: 30, speedMultiplier: 1.2 },
    medium: { count: 60, speedMultiplier: 1.0 },
    heavy: { count: 90, speedMultiplier: 0.8 }
  };
  
  const settings = intensitySettings[intensity] || intensitySettings.medium;
  const snowflakeCount = count || settings.count;

  // Generate snow flakes with random properties
  const snowflakes = Array.from({ length: snowflakeCount }, (_, i) => {
    const size = Math.random() * 3 + 3; // 3-6px (made larger for visibility)
    return {
      id: i,
      size,
      left: Math.random() * 100, // 0-100%
      animationDuration: (Math.random() * 3 + 4) * settings.speedMultiplier, // 4-7s
      animationDelay: Math.random() * 5, // 0-5s delay (reduced for faster visibility)
      opacity: Math.random() * 0.4 + 0.6, // 0.6-1.0 (made more visible)
      swayDuration: Math.random() * 2 + 3, // 3-5s sway
      swayDelay: Math.random() * 2, // 0-2s sway delay
      // Different types of snowflakes
      type: Math.floor(Math.random() * 4), // 0-3 different shapes
    };
  });

  // console.log('SnowAnimation rendering with', snowflakeCount, 'snowflakes');

  return (
    <div className="snow-container">
      {/* Debug element to test visibility */}
      {/* <div style={{
        position: 'absolute',
        top: '10px',
        left: '10px',
        background: 'red',
        color: 'white',
        padding: '5px',
        fontSize: '12px',
        zIndex: 1000
      }}>
        Snow: {snowflakeCount} flakes
      </div> */}
      
      {snowflakes.map((flake) => (
        <div
          key={flake.id}
          className={`snowflake snowflake-type-${flake.type}`}
          style={{
            '--size': `${flake.size}px`,
            '--left': `${flake.left}%`,
            '--duration': `${flake.animationDuration}s`,
            '--delay': `${flake.animationDelay}s`,
            '--opacity': flake.opacity,
            '--sway-duration': `${flake.swayDuration}s`,
            '--sway-delay': `${flake.swayDelay}s`,
          }}
        />
      ))}
    </div>
  );
});

SnowAnimation.displayName = 'SnowAnimation';

export default SnowAnimation;
